"use client";

import { createContext, useContext } from "react";

export interface SectionRenderInfo {
  sectionName: string;
  sectionIndex: number; // 0-based visible index within rendered sections
  isAlternate: boolean; // true when sectionIndex is odd and alternation is enabled
}

const SectionRenderContext = createContext<SectionRenderInfo | null>(null);

export const SectionRenderProvider = SectionRenderContext.Provider;

export const useSectionRenderInfo = (): SectionRenderInfo | null => {
  return useContext(SectionRenderContext);
};
